<template>
  <a-drawer
    title="合并订单信息"
    placement="right"
    :width="1400"
    :visible="innerVisible"
    @close="close"
    destroyOnClose
  >
    <a-card :bordered="false">
      <!-- 搜索条 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">

            <a-col :md="6" :sm="24">
              <a-form-item label="合并订单号">
                <a-input v-model="queryParam.mergeOrderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.state" placeholder="请选择" allow-clear>
                  <a-select-option v-for="item in stateOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 表格 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="rowSelection"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1500 }"
      >
        <span slot="state" slot-scope="text">
          <a-tag :color="getStateColor(text)">{{ getStateText(text) }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="loseEfficacyTime" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="handleViewDetail(record)"
            v-hasPermi="['upkeep:order-merge:query']"
          >
            详情
          </a>
          <!-- <a-divider type="vertical" v-if="record.state === 0" />
          <a
            v-if="record.state === 0"
            @click="handleConfirmMerge(record)"
            v-hasPermi="['upkeep:order-merge:confirm']"
          >
            确认
          </a>
          <a-divider type="vertical" v-if="record.state === 0" />
          <a
            v-if="record.state === 0"
            @click="handleCancelMerge(record)"
            v-hasPermi="['upkeep:order-merge:cancel']"
          >
            取消
          </a> -->
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 新建合并弹窗 -->
    <a-modal
      title="新建订单合并"
      :visible="createModalVisible"
      @ok="handleCreateOk"
      @cancel="handleCreateCancel"
      :confirmLoading="createLoading"
      width="800px"
    >
      <a-form :form="createForm" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="主订单号">
              <a-input
                v-decorator="[
                  'orderNo',
                  { rules: [{ required: true, message: '请输入主订单号' }] }
                ]"
                placeholder="请输入主订单号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合并订单号">
              <a-input
                v-decorator="[
                  'mergeOrderNo',
                  { rules: [{ required: true, message: '请输入合并订单号' }] }
                ]"
                placeholder="请输入合并订单号"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="备注">
          <a-textarea
            v-decorator="['remark']"
            placeholder="请输入合并备注"
            :rows="4"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-drawer>
</template>

<script>
import { fetchMergeList, createMerge, confirmMerge, cancelMerge, exportMerge } from '@/api/repairModule/orderMerge'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderMergeDrawer',
  mixins: [tableMixin],
  data() {
    return {
      innerVisible: false,
      createModalVisible: false,
      createLoading: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      currentRecord: null,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        mergeOrderNo: '',
        state: undefined,
      },
      stateOptions: [
        { value: 0, label: '等待确认' },
        { value: 1, label: '确认合并' },
        { value: 2, label: '否合并订单' },
        { value: 3, label: '超时取消合并' },
      ],
      columns: [

        {
          title: '主订单产品',
          dataIndex: 'orderProd',
          width: 150,
          align: 'center',
        },

        {
          title: '合并订单产品',
          dataIndex: 'mergeOrderProd',
          width: 150,
          align: 'center',
        },
        {
          title: '维修师傅',
          dataIndex: 'userName',
          width: 120,
          align: 'center',
          customRender: (text, record) => text || '-',
        },
        {
          title: '师傅电话',
          dataIndex: 'userPhone',
          width: 140,
          align: 'center',
          customRender: (text, record) => text || '-',
        },
        {
          title: '状态',
          dataIndex: 'state',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'state' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '失效时间',
          dataIndex: 'loseEfficacyTime',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'loseEfficacyTime' },
        },

        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  beforeCreate() {
    this.createForm = this.$form.createForm(this)
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.state !== 0, // 只有等待确认状态的记录可以选择
          },
        }),
      }
    },
  },
  methods: {
    // 打开抽屉
    open(record) {
      this.innerVisible = true
      this.currentRecord = record
      if (record && record.orderNo) {
        this.queryParam.orderNo = record.orderNo
      }
      this.getList()
    },

    // 关闭抽屉
    close() {
      this.innerVisible = false
      this.resetQuery()
      this.onSelectChange([], [])
      this.createModalVisible = false
      this.currentRecord = null
    },

    // 获取状态文本
    getStateText(state) {
      const stateMap = {
        0: '等待确认',
        1: '确认合并',
        2: '否合并订单',
        3: '超时取消合并',
      }
      return stateMap[state] || '-'
    },

    // 获取状态颜色
    getStateColor(state) {
      const colorMap = {
        0: 'orange',
        1: 'green',
        2: 'red',
        3: 'default',
      }
      return colorMap[state] || 'default'
    },

    // 获取列表数据
    getList() {
      this.loading = true
      fetchMergeList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    // 查询
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    // 重置查询
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        mergeOrderNo: '',
        state: undefined,
      }
      this.handleQuery()
    },

    // 显示新建合并弹窗
    handleCreateMerge() {
      this.createModalVisible = true
      this.createForm.resetFields()
    },

    // 确认新建合并
    handleCreateOk() {
      this.createForm.validateFields((errors, values) => {
        if (!errors) {
          this.createLoading = true
          createMerge(values).then(() => {
            this.$message.success('创建合并成功')
            this.createModalVisible = false
            this.getList()
          }).finally(() => {
            this.createLoading = false
          })
        }
      })
    },

    // 取消新建
    handleCreateCancel() {
      this.createModalVisible = false
    },

    // 确认合并
    handleConfirmMerge(record) {
      const ids = record ? [record.id] : this.selectedRowKeys
      if (!ids.length) {
        this.$message.warning('请选择要确认的合并记录')
        return
      }

      this.$confirm({
        title: '确认合并',
        content: `确定要确认这 ${ids.length} 条合并记录吗？`,
        onOk: () => {
          confirmMerge(ids).then(() => {
            this.$message.success('确认合并成功')
            this.onSelectChange([], [])
            this.getList()
          })
        },
      })
    },

    // 取消合并
    handleCancelMerge(record) {
      const ids = record ? [record.id] : this.selectedRowKeys
      if (!ids.length) {
        this.$message.warning('请选择要取消的合并记录')
        return
      }

      this.$confirm({
        title: '取消合并',
        content: `确定要取消这 ${ids.length} 条合并记录吗？`,
        onOk: () => {
          cancelMerge(ids).then(() => {
            this.$message.success('取消合并成功')
            this.onSelectChange([], [])
            this.getList()
          })
        },
      })
    },

    // 查看详情
    handleViewDetail(record) {
      // 这里可以打开详情弹窗或者跳转到详情页面
      this.$message.info(`查看合并记录详情：${record.orderNo} -> ${record.mergeOrderNo}`)
    },

    // 导出
    handleExport() {
      this.$confirm({
        title: '是否确认导出？',
        content: '此操作将导出当前条件下所有合并记录数据',
        onOk: () => {
          exportMerge(this.queryParam).then(response => {
            this.download(response.msg)
            this.$message.success('导出成功')
          })
        },
      })
    },

    // 分页大小改变
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    // 页码改变
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    // 选择行变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
  },
}
</script>

<style scoped>
.table-operations {
  margin-bottom: 16px;
}
</style>
